<template>
    <div v-if="content">
        <Home
            v-if="content_type.includes('home')"
            :content="content"
            />

        <Noticia 
            v-if="content_type=='news.newspage'"
            :noticia="content"
            />
        
        <Especial
            v-else-if="content_type=='specials.specialpage'"
            :content="content"
            />
        
        <Evento
            v-else-if="content_type=='events.eventpage'"
            :content="content"
            />
        
        <Video
            v-else-if="content_type=='videos.videopage'"
            :content="content"
            />
    </div>
</template>

<script>
import api from '@/api'

import Home from '@/views/Home'
import Noticia from '@/views/editorial/Noticia'
import Especial from '@/views/especiais/Detail'
import Evento from '@/views/agenda/Detail'
import Video from '@/views/video/Detail'

export default {
    name: 'Preview',
    components:{Home, Noticia, Especial, Evento, Video},
    data(){
        return {
            content: null,
            content_type: null,
        }
    },
    methods:{
        async getContent () {
            this.content_type = this.$route.query['content_type']
            const token = this.$route.query['token']
            const response = await api.get('page_preview/1', {
                content_type: this.content_type,
                token: token
            })

            if (response.ok) {
                this.content = response.data
            }
        }
    },
    mounted() {
        this.getContent()
    }
}
</script>